import { render } from "./IconTarget.vue?vue&type=template&id=7a0d4bd1&ts=true"
import script from "./IconTarget.vue?vue&type=script&lang=ts"
export * from "./IconTarget.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__